module.exports = __webpack_public_path__ + "img/work-10.67d0640d.png";